export const defaultSiteRouteSearchState = (): SiteRouteSearchState<'site'> => ({
  sort: {
    sortType: 'site',
    sortOrder: 'ascending'
  }
});
